import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import SalesSidebar from "@/components/sales/SalesSidebar";
import SalesHeader from "@/components/sales/SalesHeader";

const SalesDashboardLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="flex flex-col bg-gray-50 dark:bg-gray-900">
      <SalesHeader toggleSidebar={toggleSidebar} />
      <div className="flex flex-1 overflow-hidden">
        <SalesSidebar isOpen={sidebarOpen} />
        <main className="flex-1 overflow-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default SalesDashboardLayout;